( function() {
    "use strict";

    angular
        .module( "ccsTrApp" )
        .service( "AttachmentCustomService", AttachmentCustomService );

    AttachmentCustomService.$inject = [ "$http" ];

    function AttachmentCustomService( $http ) {
        var service = {
            uploadAttachment: uploadAttachment,
            downloadAttachment: downloadAttachment,
            returnAttachmentsByContract : returnAttachmentsByContract,
            returnAttachmentsByLr: returnAttachmentsByLr,
            returnAttachmentsByShipment : returnAttachmentsByShipment,
            returnAttachmentsByLot : returnAttachmentsByLot,
            returnAttachmentsByInvoice : returnAttachmentsByInvoice,
            returnAttachmentsByRequiredDocument: returnAttachmentsByRequiredDocument,
            returnAttachmentsByRequiredDocumentAndStatus: returnAttachmentsByRequiredDocumentAndStatus,
            returnAttachmentsByControllerPayment: returnAttachmentsByControllerPayment,
            approveAttachment: approveAttachment
        };

        return service;

        function uploadAttachment( file, type, id, filename ) {
            var url = "api/attachments/upload?id=" + id + "&type=" + type + "&filename=" + filename;
            return $http({
                url: url,
                method: "POST",
                data: file,
                headers: {'Content-Type': 'application/json'}
            });
        }

        function downloadAttachment( id ) {
            var url = "api/attachments/download/" + id;
            return $http({
                url: url,
                method: 'GET',
                responseType: 'arraybuffer'
            });
        }

        function returnAttachmentsByContract( id ) {
            var url = "api/attachments/contract/" + id;
            return $http.get( url );
        }

        function returnAttachmentsByLr( id ) {
            var url = "api/attachments/lr/" + id;
            return $http.get( url );
        }

        function returnAttachmentsByShipment( id ) {
            var url = "api/attachments/shipment/" + id;
            return $http.get( url );
        }

        function returnAttachmentsByLot( id ) {
            var url = "api/attachments/lot/" + id;
            return $http.get( url );
        }

        function returnAttachmentsByInvoice( id ) {
            var url = "api/attachments/invoice/" + id;
            return $http.get( url );
        }

        function returnAttachmentsByRequiredDocument(id) {
            var url = "api/attachments/required-document/" + id;
            return $http.get(url);
        }

        function returnAttachmentsByRequiredDocumentAndStatus(id, status) {
            var url = "api/attachments/required-document/" + id + "/approve/" + status;
            return $http.get(url);
        }

        function returnAttachmentsByControllerPayment(id) {
            var url = "api/attachments/controller-payment/" + id;
            return $http.get(url);
        }

        function approveAttachment(rdId, approvedDate, aId) {
            var url = "api/attachments/required-document/" + rdId + "/approve/" + aId + "?approvedDate=" + approvedDate;
            return $http.post(url);
        }
    }
})();
